import { Switch } from '../../components/Switch';
import React from 'react';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';

export const ResidentialSystems = () => {
  const {
    defaultMediaFirstSettings,
    defaultMediaRoomSettings,
    operator,
    updateOperator,
  } = useCreateOperator();
  const classes = useStyles();

  const defaultSwitchProps: any = {
    direction: 'row',
  };

  return (
    <>
      <div className={classes.container}>
        <Switch
          name="mediaRoom"
          label="Mediaroom:"
          checked={operator.mediaRoomSettings !== undefined}
          onChange={(event) => {
            if (event.target.checked)
              updateOperator('mediaRoomSettings', defaultMediaRoomSettings);
            else updateOperator('mediaRoomSettings', undefined);
          }}
          {...defaultSwitchProps}
        />
        <Switch
          name="mediaFirst"
          label="MediaFirst:"
          checked={operator.mediaFirstSettings !== undefined}
          onChange={(event) => {
            if (event.target.checked)
              updateOperator('mediaFirstSettings', defaultMediaFirstSettings);
            else updateOperator('mediaFirstSettings', undefined);
          }}
          {...defaultSwitchProps}
        />
      </div>
    </>
  );
};

const useStyles = () => ({
  container: 'inline-flex items-center gap-2',
});
